module.exports = __webpack_public_path__ + "7a3049629cced177816a97b9d3c65582.svg";